const { debounce } = window.BAO.Utils

class HeaderTicker extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.setupTicker = this.setupTicker.bind(this)
    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)

    this.setupTicker()

    this.onResize = debounce(this.setupTicker, 150)
    window.addEventListener('resize', this.onResize)
  }

  setupTicker () {
    const scroller = this.els?.scroller?.element
    const baseRow = this.els?.items?.element

    if (!scroller || !baseRow) return

    this.els.items.elements.slice(1).forEach((itemsEl) => itemsEl.remove())

    const cycleWidth = baseRow.offsetWidth
    if (!cycleWidth) return

    this.setupTickerSpeed(cycleWidth, scroller)

    const containerWidth = this.getBoundingClientRect().width
    const minTrackWidth = containerWidth * 2
    const copiesNeeded = Math.ceil(minTrackWidth / cycleWidth)

    const clonesRequired = Math.max(1, copiesNeeded - 1)

    Array.from({ length: clonesRequired }).forEach(() => {
      scroller.appendChild(baseRow.cloneNode(true))
    })
  }

  setupTickerSpeed (cycleWidth, scroller) {
    const secondsPerLoop = cycleWidth / this.dataset.tickerSpeed

    this.style.setProperty('--Ticker_Speed', secondsPerLoop)
    scroller.style.setProperty('--Ticker_Distance', `-${cycleWidth}px`)
  }
}

if (!customElements.get('header-ticker')) {
  customElements.define('header-ticker', HeaderTicker)
}
